export const SonioxLanguageCode = {
  AF: "af",
  SQ: "sq",
  AR: "ar",
  AZ: "az",
  EU: "eu",
  BE: "be",
  BN: "bn",
  BS: "bs",
  BG: "bg",
  CA: "ca",
  ZH: "zh",
  HR: "hr",
  CS: "cs",
  DA: "da",
  NL: "nl",
  EN: "en",
  ET: "et",
  FI: "fi",
  FR: "fr",
  GL: "gl",
  DE: "de",
  EL: "el",
  GU: "gu",
  HE: "he",
  HI: "hi",
  HU: "hu",
  ID: "id",
  IT: "it",
  JA: "ja",
  KN: "kn",
  KK: "kk",
  KO: "ko",
  LV: "lv",
  LT: "lt",
  MK: "mk",
  MS: "ms",
  ML: "ml",
  MR: "mr",
  NO: "no",
  FA: "fa",
  PL: "pl",
  PT: "pt",
  PA: "pa",
  RO: "ro",
  RU: "ru",
  SR: "sr",
  SK: "sk",
  SL: "sl",
  ES: "es",
  SW: "sw",
  SV: "sv",
  TL: "tl",
  TA: "ta",
  TE: "te",
  TH: "th",
  TR: "tr",
  UK: "uk",
  UR: "ur",
  VI: "vi",
  CY: "cy",
} as const;

export const SonioxLanguageNames = {
  [SonioxLanguageCode.AF]: "Afrikaans",
  [SonioxLanguageCode.SQ]: "Albanian",
  [SonioxLanguageCode.AR]: "Arabic",
  [SonioxLanguageCode.AZ]: "Azerbaijani",
  [SonioxLanguageCode.EU]: "Basque",
  [SonioxLanguageCode.BE]: "Belarusian",
  [SonioxLanguageCode.BN]: "Bengali",
  [SonioxLanguageCode.BS]: "Bosnian",
  [SonioxLanguageCode.BG]: "Bulgarian",
  [SonioxLanguageCode.CA]: "Catalan",
  [SonioxLanguageCode.ZH]: "Chinese",
  [SonioxLanguageCode.HR]: "Croatian",
  [SonioxLanguageCode.CS]: "Czech",
  [SonioxLanguageCode.DA]: "Danish",
  [SonioxLanguageCode.NL]: "Dutch",
  [SonioxLanguageCode.EN]: "English",
  [SonioxLanguageCode.ET]: "Estonian",
  [SonioxLanguageCode.FI]: "Finnish",
  [SonioxLanguageCode.FR]: "French",
  [SonioxLanguageCode.GL]: "Galician",
  [SonioxLanguageCode.DE]: "German",
  [SonioxLanguageCode.EL]: "Greek",
  [SonioxLanguageCode.GU]: "Gujarati",
  [SonioxLanguageCode.HE]: "Hebrew",
  [SonioxLanguageCode.HI]: "Hindi",
  [SonioxLanguageCode.HU]: "Hungarian",
  [SonioxLanguageCode.ID]: "Indonesian",
  [SonioxLanguageCode.IT]: "Italian",
  [SonioxLanguageCode.JA]: "Japanese",
  [SonioxLanguageCode.KN]: "Kannada",
  [SonioxLanguageCode.KK]: "Kazakh",
  [SonioxLanguageCode.KO]: "Korean",
  [SonioxLanguageCode.LV]: "Latvian",
  [SonioxLanguageCode.LT]: "Lithuanian",
  [SonioxLanguageCode.MK]: "Macedonian",
  [SonioxLanguageCode.MS]: "Malay",
  [SonioxLanguageCode.ML]: "Malayalam",
  [SonioxLanguageCode.MR]: "Marathi",
  [SonioxLanguageCode.NO]: "Norwegian",
  [SonioxLanguageCode.FA]: "Persian",
  [SonioxLanguageCode.PL]: "Polish",
  [SonioxLanguageCode.PT]: "Portuguese",
  [SonioxLanguageCode.PA]: "Punjabi",
  [SonioxLanguageCode.RO]: "Romanian",
  [SonioxLanguageCode.RU]: "Russian",
  [SonioxLanguageCode.SR]: "Serbian",
  [SonioxLanguageCode.SK]: "Slovak",
  [SonioxLanguageCode.SL]: "Slovenian",
  [SonioxLanguageCode.ES]: "Spanish",
  [SonioxLanguageCode.SW]: "Swahili",
  [SonioxLanguageCode.SV]: "Swedish",
  [SonioxLanguageCode.TL]: "Tagalog",
  [SonioxLanguageCode.TA]: "Tamil",
  [SonioxLanguageCode.TE]: "Telugu",
  [SonioxLanguageCode.TH]: "Thai",
  [SonioxLanguageCode.TR]: "Turkish",
  [SonioxLanguageCode.UK]: "Ukrainian",
  [SonioxLanguageCode.UR]: "Urdu",
  [SonioxLanguageCode.VI]: "Vietnamese",
  [SonioxLanguageCode.CY]: "Welsh",
} as const;

export const SonioxModel = {
  STT_RT_V4: "stt-rt-v4",
  STT_ASYNC_V4: "stt-async-v4",
} as const;

interface SonioxSettings {
  model: string;
  languageHints: Array<string>;
}

export function getSonioxTranscriptionLanguageLabel(sonioxSettings) {
  // Old: const { languageHints } = sonioxSettings; — threw when sonioxSettings was undefined
  const languageHints = sonioxSettings?.languageHints ?? [];

  if (!languageHints.length) return "";

  if (languageHints.length === 1) return SonioxLanguageNames[languageHints[0]];

  const languages = languageHints.map(
    (language) => SonioxLanguageNames[language] ?? "",
  );

  return `Multi (${languages.join(", ")})`;
}
